import * as React from 'react'

function PlusToggle(props) {
    return (
        <svg
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 40 40"
            {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M.5 7.5A1.5 1.5 0 012 6h36.083a1.5 1.5 0 110 3H2A1.5 1.5 0 01.5 7.5zm10 12.5a1.5 1.5 0 011.5-1.5h26.26a1.5 1.5 0 010 3H12a1.5 1.5 0 01-1.5-1.5zM21 31.5a1.5 1.5 0 000 3h17a1.5 1.5 0 100-3H21z"
                fill="#071D34"
            />
        </svg>
    )
}

export default PlusToggle
